<template lang="pug">
  base-content(title="個人情報保護方針")
    .content
      p 当社製品およびサービスのご利用に際し、下記に記載する目的でお客様より個人情報を提供いただきます。
      ul
        li 製品購入申し込み等々に対する当社からの返信・送付
        li 当社からの製品情報（新製品やバージョンアップなど）、キャンペーン情報、セミナー情報などのご案内のダイレクトメール（電子メールを含む）の送付または郵送、製品に関するその他の情報提供など
        li サービスと製品開発のための統計用データとしての利用
        li カスタマーハラスメント等への対応・事実確認
      p 個人情報の取り扱いに関して記載しております、下記リンクよりご確認ください。
      p: a(href="https://www.neo.co.jp/privacy/") https://www.neo.co.jp/privacy
</template>

<script>
import BaseContent from '@/components/BaseContent'
export default {
  name: 'Copyright',
  components: { BaseContent }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Copyright.vue